import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultDangerTypeOption: {
    defaultMessage: 'Select Danger Type',
    description: 'Default option for danger type dropdown',
    id: 'rEYEBf',
  },
  defaultModeTypeOption: {
    defaultMessage: 'Select Mode',
    description: 'Default option for danger mode dropdown',
    id: 'lIAZy4',
  },
  dangerousGoodsType: {
    defaultMessage: 'Dangerous Goods Type',
    description: 'Label for type of danger dropdown',
    id: 'rbhcBc',
  },
  modeType: {
    defaultMessage: 'Mode Type',
    description: 'Label for danger mode dropdown',
    id: 'FS4JIQ',
  },
  air: {
    defaultMessage: 'Air',
    description: 'One of the option in danger mode dropdown',
    id: 'kKNyyv',
  },
  ground: {
    defaultMessage: 'Ground',
    description: 'One of the option in danger mode dropdown',
    id: 'cdyWy6',
  },
  fullRegulated: {
    defaultMessage: 'Full Regulated',
    description: 'One of the option in types of danger dropdown',
    id: 'YaiYhJ',
  },
  lessThan500kgExempt: {
    defaultMessage: 'Less than 500kg Exempt',
    description: 'One of the option in types of danger dropdown',
    id: 'o6ByzA',
  },
  limitedQuantities: {
    defaultMessage: 'Limited Quantities',
    description: 'One of the option in types of danger dropdown',
    id: 'JydnFM',
  },
});
